import React from 'react';
import DentalServicePage from './DentalServicePage';

const DentalImplants = () => {
    // Defined content for Dental Implants
    const serviceName = 'Dental Implants';
    const serviceTagline = 'Restore your smile with permanent, natural-looking dental implants';

    const whatIsContent = [
        'Dental implants are titanium posts surgically placed into the jawbone beneath your gums to replace missing tooth roots. Once in place, they allow your dentist to mount replacement teeth onto them, providing a strong foundation for fixed or removable replacement teeth.',
        "Unlike dentures, implants don't come loose or require adhesives. Unlike fixed bridges, implants don't require reducing other teeth. With proper care, dental implants can last a lifetime, making them one of the best long-term investments for tooth replacement.",
    ];

    const whenRequiredContent = {
        paragraphs: [
            'Dental implants are an excellent solution for tooth loss and can dramatically improve your oral health and quality of life.',
        ],
        listIntro: 'You may be a candidate for dental implants if you:',
        list: [
            'Have one or more missing teeth',
            'Have a jawbone that has reached full growth',
            'Have adequate bone to secure the implants (or are able to have a bone graft)',
            'Have healthy oral tissues',
            "Don't have health conditions that affect bone healing",
            'Are unable or unwilling to wear dentures',
            'Want to improve your speech and comfort',
            'Are committed to the process (which can take several months)',
        ],
        closing:
            'During your consultation at Wisdom Dental Clinic, our specialists will evaluate your specific needs and determine if implants are right for you.',
    };

    const howDoneContent = {
        paragraphs: [
            'At Wisdom Dental Clinic, our implant procedures combine cutting-edge technology with experienced specialists to deliver exceptional results.',
        ],
        listIntro: 'Our dental implant services feature:',
        list: [
            '3D CT scanning for precise implant placement planning',
            'Computer-guided implant surgery for accuracy and comfort',
            'Premium implant systems with lifetime warranties',
            'Minimally invasive techniques for faster healing',
            'Single-visit options for some cases',
            'Sedation dentistry for anxious patients',
        ],
        closing:
            'Our dental implant specialists have completed advanced training and have placed thousands of successful implants. We customize each treatment plan to address your specific needs, aesthetic goals, and budget considerations.',
    };

    const benefitsContent = [
        {
            title: 'Natural Appearance',
            description: 'Implants look and feel like your natural teeth, with customized color matching',
        },
        {
            title: 'Improved Comfort',
            description: 'Implants eliminate the discomfort of removable dentures',
        },
        {
            title: 'Better Speech',
            description: 'Unlike slipping dentures, implants allow you to speak without worry',
        },
        {
            title: 'Easier Eating',
            description: 'Implants function like your own teeth, allowing you to eat with confidence',
        },
        {
            title: 'Improved Oral Health',
            description: "Implants don't require reducing other teeth, improving long-term oral health",
        },
        {
            title: 'Durability',
            description: 'With proper care, implants can last a lifetime',
        },
    ];

    const procedureSteps = [
        {
            title: 'Initial Consultation',
            description: 'Comprehensive examination including 3D imaging to assess bone quality and plan treatment',
        },
        {
            title: 'Preparatory Procedures',
            description: 'Any necessary extractions, bone grafting, or gum disease treatment is completed',
        },
        {
            title: 'Implant Placement',
            description: 'The titanium implant is surgically placed into the jawbone under local anesthesia',
        },
        {
            title: 'Healing Period',
            description: 'The implant integrates with your jawbone over 3-6 months (osseointegration)',
        },
        {
            title: 'Abutment Placement',
            description: 'Once healed, an abutment is attached to the implant to connect it to the crown',
        },
        {
            title: 'Crown Placement',
            description: 'A custom-made crown matching your natural teeth is attached to the abutment',
        },
    ];

    const seoData = {
        title: 'Dental Implant Clinics in Sector 23, Palam Vihar, Gurgaon',
        description:
            'Looking for the Best Dental Implant Clinic in Sector 23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers affordable implant treatments. Call now!',
        keywords:
            'Dental Implant Clinics in Gurgaon,Best Dental Implants Clinic in Gurgaon,Dental implants in Gurgaon,Dental implants Near Me, Dental implants Sector 23 gurgaon, Dental implants palam vihar gurgaon',
        canonical: 'https://wisdomdentalclinics.in/dental-implants',
        ogTitle: 'Dental Implant Clinics in Sector 23, Palam Vihar, Gurgaon',
        ogDescription:
            'Looking for the Best Dental Implant Clinic in Sector 23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers affordable implant treatments. Call now!',
        twitterTitle: 'Dental Implant Clinics in Sector 23, Palam Vihar, Gurgaon',
        twitterDescription:
            'Looking for the Best Dental Implant Clinic in Sector 23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers affordable implant treatments. Call now!',
        h1Text: 'Dental Implant Clinics in Sector 23 Palam Vihar Gurgaon',
    };

    return (
        <DentalServicePage
            serviceName={serviceName}
            serviceTagline={serviceTagline}
            whatIsContent={whatIsContent}
            whenRequiredContent={whenRequiredContent}
            howDoneContent={howDoneContent}
            benefitsContent={benefitsContent}
            procedureSteps={procedureSteps}
            seoData={seoData}
        />
    );
};

export default DentalImplants;
